class Buyout {
    constructor(buyout) {
        this.buyout = document.getElementById(buyout);
        this.title = this.buyout?.getAttribute('data-currencytitle')
        this.profityes = this.buyout?.getAttribute('data-profityes')
        this.profitno = this.buyout?.getAttribute('data-profitno')
        this.init();
    }
    
    init() {
        if(this.buyout){
            this.setupJQueryPlugins();
            const propertyValue = this.buyout.querySelector('#property_value');
            propertyValue.addEventListener('input', () => this.numberOnly(propertyValue.id));
            
            const percentFinanceInput = this.buyout.querySelector('#percent_finance_input');
            percentFinanceInput.addEventListener('input', () => this.numberOnly(percentFinanceInput.id));
            
            const tenureInput = this.buyout.querySelector('#tenure_input');
            tenureInput.addEventListener('input', () => this.numberOnly(tenureInput.id));
            
            const btnCalculate = this.buyout.querySelector('#btnCalculate');
            btnCalculate.addEventListener('click', () => this.calculateInstallment());
    
            const btnReset = this.buyout.querySelector('#btnReset');
            btnReset.addEventListener('click', () => this.clearFields());
    
            const radiosalarytransferyes = this.buyout.querySelector('#radio-salary-transfer-yes')
            const radiosalarytransferno = this.buyout.querySelector('#radio-salary-transfer-no')
            radiosalarytransferyes.addEventListener('click',()=>this.calculateInstallment())
            radiosalarytransferno.addEventListener('click',()=>this.calculateInstallment())
        }
    }

    setupJQueryPlugins() {
            const pathname = window.location.href;
            
            let checkLang = document.querySelector("html").getAttribute('lang');
            
           let max = $(this.buyout).find("#percent_finance").attr('data-slider-max');
           let min =  $(this.buyout).find("#percent_finance").attr('data-slider-min');
           let step =  $(this.buyout).find("#percent_finance").attr('data-slider-step');
           let value =  $(this.buyout).find("#percent_finance_input").attr('data-slider-initialvalue');
        //    let lang = 'ar'
            $(this.buyout).find("#percent_finance").slider({
                range: "min",
                value: parseInt(value) || 0 ,
                min: parseInt(min) || 0,
                max: parseInt(max) || 85,
                step: parseInt(step) || 1,
                isRTL: checkLang === 'ar' ? true : false,
                slide: (event, ui) => {
                    $('#percent_finance_input').val(ui.value);
                },
   
            });
            
           let tenuremax = $(this.buyout).find("#tenure").attr('data-slider-max');
           let tenuremin =  $(this.buyout).find("#tenure").attr('data-slider-min');
           let tenurestep =  $(this.buyout).find("#tenure").attr('data-slider-step');
           let tenurevalue =  $(this.buyout).find("#tenure_input").attr('data-slider-initialvalue');
            $(this.buyout).find("#tenure").slider({
                range: "min",
                value: parseInt(tenurevalue)||0,
                min: parseInt(tenuremin) || 0,
                max: parseInt(tenuremax) || 25,
                step: parseInt(tenurestep) || 1,
                isRTL: checkLang === 'ar' ? true : false,
                slide: (event, ui) => {
                    $('#tenure_input').val(ui.value);
                }
            });

            $(this.buyout).find('[id$="radio-salary-transfer-yes"]').click(() => {
                $('[id$="profit_rate"]').text(this.profityes + "%");
                this.calculateInstallment();
            });

            $(this.buyout).find('[id$="radio-salary-transfer-no"]').click(() => {
                $('[id$="profit_rate"]').text(this.profitno + "%");
                this.calculateInstallment();
            });

            this.clearFields();
    }

    clearFields() {
        $(this.buyout).find('[id$="profit_rate"]').text(this.profityes + "%");
        $(this.buyout).find('[id$="total_finance_amount"]').text(this.title + "0");
        $(this.buyout).find('[id$="monthly_installment"]').text(this.title + "0");

        $(this.buyout).find("#radio-salary-transfer-yes").prop("checked", true);
        $(this.buyout).find("#radio-salary-transfer-no").prop("checked", false);

        $(this.buyout).find('#property_value').val("0");
        $(this.buyout).find('#percent_finance_input').val("0");
        $(this.buyout).find('#tenure_input').val("0");

        $(this.buyout).find("#percent_finance").slider("value", 0);
        $(this.buyout).find("#tenure").slider("value", 0);
    }

    numberOnly(id) {
        const element = document.getElementById(id);
        element.value = element.value.replace(/[^0-9]/g, "");
    }

    calculateInstallment() {
        const propertyValue = parseFloat($("#property_value").val());
        const percentFinance = parseFloat($("#percent_finance_input").val());
        const tenure = parseFloat($("#tenure_input").val());
        let profitRate = parseFloat($('[id$="profit_rate"]').text().replace('%', ''));

        const totalFinanceAmt = (propertyValue * percentFinance / 100);
        if (!isNaN(totalFinanceAmt)) {
            $('[id$="total_finance_amount"]').text(this.title + totalFinanceAmt);
        }

        if (tenure !== 0) {
            const monthlyInstallments = Math.round(totalFinanceAmt * (profitRate / 12) / 100 * (Math.pow(1 + (profitRate / 12) / 100, tenure * 12) / (Math.pow(1 + (profitRate / 12) / 100, tenure * 12) - 1)));
            if (!isNaN(monthlyInstallments)) {
                $('[id$="monthly_installment"]').text(this.title + monthlyInstallments);
            }
        } else {
            $('[id$="monthly_installment"]').text(this.title + "0");
        }
    }
}

export default Buyout;
